var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(0, 0.5)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.70710676,0.292893203 C1.31658247,-0.09763109 0.683417484,-0.09763109 0.292893191,0.292893203 C-0.0976311025,0.683417497 -0.0976311025,1.31658248 0.292893191,1.70710677 L6.29289322,7.7071068 C6.68341751,8.09763109 7.31658249,8.09763109 7.70710678,7.7071068 L13.7071068,1.70710677 C14.0976311,1.31658248 14.0976311,0.683417497 13.7071068,0.292893203 C13.3165825,-0.09763109 12.6834175,-0.09763109 12.2928932,0.292893203 L6.99999997,5.58578644 L1.70710676,0.292893203 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.1b644ddaebc281bb4644be276aa158c4.svg";
export { ForwardRef as ReactComponent };